import styled from '@emotion/styled'

export const ToolbarWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--lumen-spacing-8);
  width: 100%;
`

export const SearchWrapper = styled.div`
  flex: 1;
  width: 100%;
`
